import { useState, useContext, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { setModal } from '../../slices/modalSlice'
import { CarritoContext } from '../context/carritoContext'
import {
  calcularTotalItemConIva,
  calcularTotalItemSinIva
} from '../helpers/calcularPrecioTotal'
import ComponenteError from '../publicaciones/ComponenteError'
import { GenericModal } from '../reutilizables/modal/GenericModal'
import Precios from '../reutilizables/precios/Precios'
import * as carritoService from '../servicios/carritoService'
import BordePrincipal from '../ui/BordePrincipal'
import styles from './Carrito.module.css'
import CarritoItem from './CarritoItem'

export const Carrito = () => {
  const {
    setCantidad,
    items,
    setItems,
    setIdPresupuestoComprar,
    setIdPublicacionComprar,
    getImputacion
  } = useContext(CarritoContext)

  const [totalSuma, setTotalSuma] = useState(0)
  const [sumaTotal, setSumaTotal] = useState(0)
  const [itemsSeparados, setItemsSeparados] = useState([])
  const [centroDeCostos, setCentroDeCostos] = useState(null)
  const [tipoConfirmacion, setTipoConfirmacion] = useState(null)
  const [itemAEliminar, setItemAEliminar] = useState(null)
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const centroDeCostosLlamado = async () => {
    const resp = await getImputacion()
    const opcionesImputTpos = resp.opcionesImputTpos.map((element) => {
      return { value: element.tipoImpu, label: element.tipoImpuTextos }
    })
    const listaImputaciones = resp.listaImputaciones.map((element) => {
      return {
        codigo: element.activoFijo || element.codigo,
        descripcion: element.descripcion,
        tipoImpu: element.tipoImpu
      }
    })
    setCentroDeCostos({
      ...resp,
      opcionesImputTpos,
      listaImputaciones
    })
  }

  useEffect(() => {
    !centroDeCostos && centroDeCostosLlamado()
    sumarTotales()
  }, [totalSuma])

  const sumar = (valor) => {
    setTotalSuma(valor)
  }

  useEffect(() => {
    setIdPresupuestoComprar(0)
    setIdPublicacionComprar(0)
  }, [setIdPresupuestoComprar, setIdPublicacionComprar])

  useEffect(() => {
    setItemsSeparados(
      Object.values(
        items.reduce((acc, item) => {
          if (!acc[item.idVendedor]) {
            acc[item.idVendedor] = []
          }
          acc[item.idVendedor].push({
            ...item,
            valorTotalConIva: calcularTotalItemConIva(item),
            valorTotalSinIva: calcularTotalItemSinIva(item)
          })
          return acc
        }, {})
      )
    )
  }, [items])

  const handleCloseConfirm = () => {
    setTipoConfirmacion(null)
    setItemAEliminar(null)
  }

  const handleConfirmarBorradoItem = (id) => {
    openConfirm('item', id)
  }

  const confirmarBorrado = async () => {
    if (tipoConfirmacion === 'carrito') {
      await deleteCarritoCompleto()
    } else if (tipoConfirmacion === 'item' && itemAEliminar) {
      await deleteCarritoItem(itemAEliminar)
    }
    handleCloseConfirm()
    return true
  }

  const deleteCarritoItem = async (idpub) => {
    const item = items.find((item) => item.idPublicacion === idpub)
    setSumaTotal(sumaTotal - calcularTotalItemConIva(item))
    const newItems = items.filter((item) => item.idPublicacion !== idpub)
    setItems(newItems)

    const carritoEliminar = {
      idPublicacion: idpub,
      idUsuario: parseInt(localStorage.getItem('idUsuario'))
    }
    const { data: carritoCantidad } = await carritoService.eliminar(carritoEliminar)
    setCantidad(carritoCantidad)
  }

  const deleteCarritoCompleto = async () => {
    const idUsuario = parseInt(localStorage.getItem('idUsuario'))
    items.forEach(async (item) => {
      const carritoEliminar = {
        idPublicacion: item.idPublicacion,
        idUsuario
      }
      await carritoService.eliminar(carritoEliminar)
    })
    setSumaTotal(0)
    setCantidad(0)
    setItems([])
  }

  const sumarTotales = async () => {
    const totalItems = items.map((item) => calcularTotalItemConIva(item))
    const arrTotalesSinIVA = items.map((item) => calcularTotalItemSinIva(item))

    let total = 0
    let totalSinIva = 0
    for (let i = 0; i < totalItems.length; i++) {
      total = total + totalItems[i]
      totalSinIva = totalSinIva + arrTotalesSinIVA[i]
    }
    setSumaTotal(total)
  }

  const modificarCarrito = (valor, propiedad, item) => {
    const itemsModificados = items.map((i) =>
      i.idPublicacion === item ? { ...i, [propiedad]: valor } : i
    )
    setItems(itemsModificados)
  }

  const copiar = (propiedad, valorAReplicar) => {
    setItems((prev) =>
      prev.map((i) =>
        i[propiedad] === valorAReplicar ? i : { ...i, [propiedad]: valorAReplicar }
      )
    )
  }

  const irAPublicacionesFiltrandoPorVendedor = (grupo) => {
    const { idVendedor, razonSocial } = grupo[0]
    navigate('/Publicaciones', {
      state: { idVendedorCarrito: idVendedor, razonSocial }
    })
  }

  const openConfirm = (tipo, idItem = null) => {
    setTipoConfirmacion(tipo)
    setItemAEliminar(idItem)

    const body =
      tipo === 'carrito'
        ? '¿Estás seguro de que querés eliminar todo el carrito?'
        : '¿Estás seguro de que querés eliminar esta publicación del carrito?'

    dispatch(
      setModal({
        size: 'sm',
        title: 'Confirmar eliminación',
        type: 'botones',
        body: body,
        show: true
      })
    )
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-9 mb-3">
          <BordePrincipal titulo="Mi Carrito">
            {items.length > 0 && (
              <div className={styles.posicionBoton}>
                <Button
                  variant="light"
                  className={styles.btnBackground}
                  onClick={() => openConfirm('carrito')}
                >
                  <i className={`bi bi-trash-fill ${styles.btnIconColor}`}></i>
                </Button>
              </div>
            )}
            <div
              className={`d-flex justify-content-center ${styles.botonWidth} ${styles.posicionVolverPublicaciones}`}
            >
              <Link to="/Publicaciones/">Ver más publicaciones</Link>
            </div>
            <div className={`mb-5 ${styles.marginTopTitulo} ${styles.gapCarrito}`}>
              {itemsSeparados.map((grupo, indexGrupo) => (
                <div key={indexGrupo} className={styles.grupoCarrito}>
                  <div
                    className={`d-flex justify-content-between align-items-center ${styles.grupoTitulo} mb-3`}
                  >
                    <button
                      className={styles.buttonPublicaciones}
                      title="Ver más publicaciones de este proveedor"
                      onClick={() => irAPublicacionesFiltrandoPorVendedor(grupo)}
                    >
                      <h5 className={styles.tituloVendedor}>
                        Vendedor {grupo[0].razonSocial}
                      </h5>
                    </button>
                    <div className="d-flex flex-column align-items-center">
                      <Precios
                        nombre={'Subtotal'}
                        items={grupo}
                        showSinIVA={true}
                        monedaSimbolo={'$'}
                      />
                    </div>
                  </div>
                  {grupo.map((item) => (
                    <CarritoItem
                      key={item.idPublicacion}
                      item={item}
                      onDelete={handleConfirmarBorradoItem}
                      sumar={sumar}
                      setTotalSuma={setTotalSuma}
                      totalSuma={totalSuma}
                      sumarTotales={sumarTotales}
                      centroDeCostos={centroDeCostos}
                      modificarCarrito={modificarCarrito}
                      copiar={copiar}
                      setItems={setItems}
                      items={items}
                    />
                  ))}
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center align-items-center gap-3">
              {items.length === 0 && <ComponenteError tipo="I" idAviso={4} />}
            </div>
          </BordePrincipal>
        </div>
        <div className="col-12 col-lg-2">
          {items.length > 0 && (
            <BordePrincipal>
              <h4 className="m-0 text-center mb-5">Resumen de compra</h4>
              <div className="d-flex flex-column align-items-center gap-2">
                <Precios
                  nombre={'Total'}
                  items={items}
                  showSinIVA={true}
                  monedaSimbolo={'$'}
                />
              </div>

              <div className="row justify-content-center mt-5">
                <div className={`d-flex justify-content-center ${styles.botonWidth}`}>
                  <Link type="button" className="btn btn-volver-comprar" to={'/compras'}>
                    Continuar compra
                  </Link>
                </div>
              </div>
            </BordePrincipal>
          )}
        </div>
      </div>

      <GenericModal onClose={handleCloseConfirm} onConfirm={confirmarBorrado} />
    </>
  )
}
